export default "__VITE_ASSET__0049530e__"